import { TIDY_SAVE_DELAY_MS, TIDY_ELK_WAIT_MAX_MS } from './constants';
import { buildPositionChangesFromAutoPositions } from './positionChangeBuilders';
import { flushTidyPositionChanges } from './flushTidySaves';

/**
 * After delay, copy auto positions into customPositions and persist (ELK-aware).
 */
export function scheduleSingleCampaignFullTidyPersist({
  tidyGeneration,
  fullTidyPersistGenerationRef,
  tidyStartedAt,
  isMultiCampaignMode,
  elkPositionsOkRef,
  autoPositionsRef,
  interaction,
  tasks,
  onPositionChangeBatch,
  onPositionChange,
  options,
  skipSave = false,
}) {
  setTimeout(() => {
    const finishPersist = () => {
      if (tidyGeneration !== fullTidyPersistGenerationRef.current) return;

      const mustWaitForElk =
        !isMultiCampaignMode &&
        elkPositionsOkRef &&
        elkPositionsOkRef.current === false &&
        Date.now() - tidyStartedAt < TIDY_ELK_WAIT_MAX_MS;

      if (mustWaitForElk) {
        requestAnimationFrame(finishPersist);
        return;
      }

      const autoPos = autoPositionsRef.current;
      if (interaction.setCustomPositions) {
        interaction.setCustomPositions(autoPos);
      }

      if (skipSave) return;

      const positionChanges = buildPositionChangesFromAutoPositions(tasks, autoPos);
      flushTidyPositionChanges(
        positionChanges,
        { skipRecordAction: options.skipRecordAction },
        onPositionChangeBatch,
        onPositionChange,
      );
    };

    finishPersist();
  }, TIDY_SAVE_DELAY_MS);
}
